module.exports = "<p>\n  nav-drawer works!\n</p>\n"